<template>
  <div class="f-vcreator-sources-container">
    <f-sexy-scroll>
      <div class="v-vcreator-templates-container" :class="{ blurme: subtemplate }">
        <div class="f-subtitle" v-html="$vt(subtitle)"></div>
        <div class="f-vcreator-sources">
          <template v-for="template in sortedSources">
            <div
              v-if="template.value['#type'].indexOf('vcreator18:collection') !== -1"
              class="f-vcreator-source"
              @click.stop="showModal(template.value)"
              v-tippy="{ placement: 'bottom', arrow: true, delay: [150, 300], allowHTML: true, interactive: true, onShow: (i) => !!i.props.content }"
              :title="$vt(template.value.tooltip)"
            >
              <f-icon :icon="template.value.icon"></f-icon>
              <div class="f-title">{{ $vt(template.value.title) }}</div>
              <f-button type="link">
                {{ $vt('View') }} ({{ Object.values(template.value.templates.values).length }})
              </f-button>
            </div>
            <f-creator-template
              v-if="template.value['#type'].indexOf('vcreator18:template') !== -1 && !(template.value.hidden_if_unauthorized && !template.value['#actions']['create'])"
              :component="template.value"
              :handler="handler"
              @oncreate="$emit('oncreate', $event)"
            ></f-creator-template>
          </template>
        </div>
      </div>

      <div class="v18-vcreator-source-limit-reached" v-show="isOverlimits">
        <f-thumb selected no-hover>
          <div v-html="$vt(overlimitsMessage || 'You cannot create more sources for this project.')"></div>
        </f-thumb>
      </div>

      <div class="f-vcreator-modal" v-if="subtemplate">
        <f-sexy-scroll>
          <div>
            <div class="f-goback">
              <f-button type="icon tertiary overlay" @click="hideModal()">
                <f-icon icon="fa6-arrow-left"></f-icon>
              </f-button>
              {{ $vt(title) }}
            </div>
            <div class="f-subtitle">{{ $vt(subtemplate.tooltip) }}</div>
            <div class="f-vcreator-sources" v-click-outside="hideModal">
              <template v-for="template in subtemplate.templates.values">
                <f-creator-template
                  v-if="!(template.value.hidden_if_unauthorized && !template.value['#actions']['create'])"
                  :component="template.value"
                  :handler="handler"
                  @oncreate="$emit('oncreate', $event)"
                ></f-creator-template>
              </template>
            </div>
          </div>
        </f-sexy-scroll>
      </div>
    </f-sexy-scroll>
  </div>
</template>

<script>
import FCreatorTemplate from './FCreatorTemplate.vue'

export default {
  translate25Context: 'vcreator18',
  components: { FCreatorTemplate },
  props: {
    handler: Object,
    sources: Object,
    title: String,
    subtitle: String,
    overlimitsMessage: String,
    isOverlimits: Boolean,
  },
  data() {
    return {
      subtemplate: null,
    }
  },
  computed: {
    sortedSources() {
      if (!this.sources) return []
      return Object.values(this.sources).slice().sort((a, b) => {
        const aDisabled = !a.value || !a.value.permission_value
        const bDisabled = !b.value || !b.value.permission_value
        if (aDisabled === bDisabled) return 0
        return aDisabled ? 1 : -1
      })
    },
  },
  methods: {
    showModal(subtemplate) {
      this.subtemplate = subtemplate
    },
    hideModal() {
      if (this.subtemplate === null) return
      for (const nid in this.subtemplate.templates.values) {
        if (this.subtemplate.templates.values[nid].value._pending) {
          return
        }
      }
      this.subtemplate = null
    },
  },
}
</script>
